export const determineState = (info) => {
  if (info.userInfoSliceState.accountType !== 3) {
    if (
      info.utilityName === "TAKSAT_DURRES" ||
      info.utilityName === "TAKSAT_SHKODER" ||
      info.utilityName === "Siguracione"
    ) {
      return "offlineTaxes";
    } else if (info.contracts.length === 0) {
      return "noContracts";
    } else {
      if (info.location === "dashboard") {
        return "dashboard";
      } else if (info.location === "utility") {
        return "utility";
      }
    }
  } else {
    return "basicAccount";
  }
};
